import { render } from "./DropDownsPage.vue?vue&type=template&id=ec67e260"
import script from "./DropDownsPage.vue?vue&type=script&lang=js"
export * from "./DropDownsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__